import React from "react";
import { Checkbox } from "@/components/ui/checkbox";

export default function ChecklistBlock({ block, value = {}, onChange }) {
  const toggle = (k) => onChange({ ...value, [k]: !value[k] });
  const done = block.items.filter((it) => value[it.k]).length;
  return (
    <div className="rounded-xl border border-border bg-card/60 p-4 sm:p-5 print-avoid-break">
      {block.title && (
        <div className="mb-3 flex items-center justify-between gap-3">
          <h4 className="text-sm font-semibold uppercase tracking-wider text-foreground">{block.title}</h4>
          <span className="font-mono text-xs text-muted-foreground">{done}/{block.items.length}</span>
        </div>
      )}
      <div className="grid grid-cols-1 gap-1.5">
        {block.items.map((it) => (
          <label
            key={it.k}
            data-testid={`check-${block.key}-${it.k}`}
            className="flex min-h-[44px] cursor-pointer items-start gap-3 rounded-lg px-3 py-2.5 tap-scale hover:bg-secondary/60"
            onClick={(e) => { e.preventDefault(); toggle(it.k); }}
          >
            <Checkbox checked={!!value[it.k]} className="mt-0.5 data-[state=checked]:bg-primary data-[state=checked]:border-primary" />
            <span className={`text-sm leading-snug ${value[it.k] ? "text-muted-foreground line-through" : "text-foreground"}`}>{it.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
}
